import { useTranslation, useI18next } from 'gatsby-plugin-react-i18next';

type Navigation = {
  name: string;
  url: string;
}

export type NavLinks = Navigation & {
  isActive: boolean
}

export const useNavigationLinks = (): NavLinks[] => {
  const { t } = useTranslation();
  const { originalPath } = useI18next();
  const translationsLinks: Navigation[] = t('navigation', {
    returnObjects: true,
  });

  return Object.values(translationsLinks).map((item) => ({
    ...item,
    isActive: item?.url?.replace(/\//g, '') === originalPath.replace(/\//g, ''),
  }));
};
